import { render, staticRenderFns } from "./smartwatch-overview.page.vue?vue&type=template&id=537f0da9&scoped=true&"
import script from "./smartwatch-overview.page.vue?vue&type=script&lang=js&"
export * from "./smartwatch-overview.page.vue?vue&type=script&lang=js&"
import style0 from "./smartwatch-overview.page.vue?vue&type=style&index=0&id=537f0da9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f0da9",
  null
  
)

export default component.exports